/* Google — DS-04 (Bible §19/§56).
   Three capabilities that never imply one another: link, reporting, response.
   Reporting is timestamped snapshots — no backfill, stale badge when old. */
import { useNavigate } from 'react-router-dom'
import { Button, ErrorState, ListRow, Note } from '@/ui'
import { useGoogle } from './api'
import { Chargement, Etat, Retour } from './parts'

export default function Google() {
  const { data, isPending, isError, refetch } = useGoogle()
  const nav = useNavigate()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger l’état de la connexion Google."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 700 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Google — {data.location}</h2>

      <section>
        {data.capabilities.map(c => (
          <ListRow key={c.id} title={c.name} meta={c.meta} end={<Etat tone={c.tone} label={c.label} />} />
        ))}
      </section>

      {data.drift && (
        <Note tone="candour">
          <b>La fiche liée à «&nbsp;{data.drift.location}&nbsp;» semble avoir changé</b> (nom ou adresse).
          Le rapport est marqué « à vérifier » en attendant — jamais des zéros inventés.
          {' '}<a href="#" onClick={e => { e.preventDefault(); nav('/destinations/fiche') }}>Comparer et re-confirmer</a>
        </Note>
      )}

      <Note tone="candour">
        Un lien valide ne donne accès ni aux notes, ni au texte des avis, ni aux réponses.
        Chaque capacité se connecte — et se déconnecte — séparément.
      </Note>
    </div>
  )
}
